import type { AnalyticsTrendPoint } from "../api/analytics.js";

/** Ratios use summed components, so a quiet day cannot outweigh a busy one. */
export function summarizeGapObservations(points: AnalyticsTrendPoint[]) {
  const totals = points.reduce((acc, point) => ({
    captures: acc.captures + point.captures,
    analyzedCaptures: acc.analyzedCaptures + point.analyzedCaptures,
    facings: acc.facings + point.facings,
    gaps: acc.gaps + point.oosCount,
  }), { captures: 0, analyzedCaptures: 0, facings: 0, gaps: 0 });
  const denominator = totals.facings + totals.gaps;
  const observed = points.flatMap((p) => p.observedThrough ? [p.observedThrough] : []).sort();
  const computed = points.flatMap((p) => p.computedAt ? [p.computedAt] : []).sort();
  return {
    ...totals,
    ratePct: denominator > 0 ? totals.gaps / denominator * 100 : null,
    observedThrough: observed.at(-1) ?? null,
    computedAt: computed.at(0) ?? null,
  };
}
